function BlurredBackground() {
  return (
    <div className="w-full min-h-screen bg-black bg-tree flex justify-center blur-lg scale-110 overflow-hidden fixed z-0 top-0 left-0"></div>
  );
}

export default BlurredBackground;
